// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    MAX_NUM_OF_PRODUCT_BADGES,
    productBadgesCarouselStyles,
} from "@pace/App/Widgets/Product/ProductBadgesCarousel";
import { css } from "styled-components";

import { hideElementOnPrint, sharedBadgeStyle } from "@pace/XDL/Utilities";

productBadgesCarouselStyles.wrapper = {
    css: css`
        max-width: calc(32px * ${MAX_NUM_OF_PRODUCT_BADGES});
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
};

productBadgesCarouselStyles.imageItem = {
    css: css`
        display: flex;
        flex: 1;
        max-width: 100%;
        .tooltip-container > span {
            margin: 0;
        }
    `,
};

productBadgesCarouselStyles.badgeImageProps = {
    width: 24,
    height: 24,
};

productBadgesCarouselStyles.textBadge = {
    ...sharedBadgeStyle.badgeText,
};

productBadgesCarouselStyles.textBadgeContainer = {
    css: css`
        & > div {
            padding: 6px;
            border-radius: 4px;
            width: fit-content;
        }
    `,
};

productBadgesCarouselStyles.swiper = {
    container: {
        css: css`
            ${hideElementOnPrint}
            .swiper-slide {
                max-width: 24px;
            }
        `,
    },
};
